import axios from 'axios';

const axiosWrapper = axios.create({
  withCredentials: true
});

export default axiosWrapper;